import React, { useState, useEffect } from "react"
import { Box, Grid, Typography, CircularProgress } from "@mui/material"
import RecipeCard from "./recipeCard"

const FilteredRecipes = ({ selectedCategory }) => {
  const [recipes, setRecipes] = useState([])
  const [loading, setLoading] = useState(true) // State to track loading

  // fetch recipes from backend
  useEffect(() => {
    const fetchRecipes = async () => {
      try {
        const response = await fetch("/api/recipes/")
        if (!response.ok) {
          throw new Error("Network response was not ok")
        }
        const recipes = await response.json()
        setRecipes(recipes)
      } catch (error) {
        console.error("Error fetching recipes:", error)
      } finally {
        setLoading(false) // Stop loading after fetching is complete
      }
    }

    fetchRecipes()
  }, [])

  // Filter recipes based on selected category
  const filteredRecipes = recipes.filter((recipe) => {
    return recipe.selectedTags.includes(selectedCategory)
  })

  return (
    <Box mt={4}>
      <Typography variant="h4" component="div" mb={2}>
        Recipes: {selectedCategory}
      </Typography>

      {loading ? ( // Display spinner if loading is true
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : filteredRecipes.length === 0 ? ( // Display message if no recipes are found
        <Typography variant="h6" component="div" mt={4}>
          No results found for "{selectedCategory}"
        </Typography>
      ) : (
        // Otherwise, display the list of recipes
        <Grid container spacing={4} key={0}>
          {filteredRecipes.map((recipe) => (
            <Grid item xs={12} md={3} key={recipe.id}>
              <RecipeCard recipe={recipe} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  )
}

export default FilteredRecipes
